<template lang="html">
    <div class="row form-item">
        <div :class="`col-sm-${type.left} rowTitle`"><span v-if="isRequired" class="required-content">*</span>{{title}}</div>
        <div :class="`col-sm-${type.right}`">
            <slot></slot>
        </div>
    </div>
</template>
<style scoped>
    .required-content {
        color: #ff401c;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        transform: translate(-2px, 4px);
        font-weight: normal !important;
    }
    .rowTitle {
        text-align: right;
    }
    .form-item {
        margin-bottom: 23px;
        line-height: 36px;
    }
</style>
<script>
    // import { mapState } from 'vuex'
    export default {
        name: 'content-block',
        props: {
            title: String,
            isRequired: {
                type: Boolean,
                default: false
            },
            type: {
                Object,
                default: () => {
                    return {
                        left: 2,
                        right: 9
                    }
                }
            }
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?691c6cf0